import { IActionCenterToDo, IPendingSwap, IActionCenterOther, IActionCenterCompliance } from "../../models";
import { IActionCenterLookupData } from "./actions";
import { IRpChainEndDeclineRatio } from "@nkr/models/center-performance/relative-performance";

export interface IPendingSwaps {
    recipientSwaps: IPendingSwap[],
    internalSwaps: IPendingSwap[],
    donorSwaps: IPendingSwap[],
    remoteDonorsYourCenter: IPendingSwap[],
    remoteDonorsOtherCenter: IPendingSwap[],
}

export interface IActionCenterState {
    todo: IActionCenterToDo,
    other: IActionCenterOther,
    compliance: IActionCenterCompliance,
    pendingSwaps: IPendingSwaps,
    pastTransplants: IPendingSwaps,
    lookupData: IActionCenterLookupData,
    chainEndDeclineRatio?: IRpChainEndDeclineRatio
}
